import {
  Card,
  CardActionArea,
  CardContent,
  CardMedia,
  Typography,
} from "@mui/material";
import { ReactNode } from "react";
import { useNavigate } from "react-router-dom";

export interface ImageLinkCardProps {
  title: string;
  description: string;
  slug?: string;
  icon: ReactNode;
  color?: string;
}

const ImageLinkCard = ({
  title,
  description,
  slug,
  icon,
  color = "accent.main",
}: ImageLinkCardProps) => {
  const navigate = useNavigate();
  const handleClick = () => {
    if (!slug) return;
    navigate(slug);
  };
  return (
    <Card sx={{ width: "100%", height: 275 }} elevation={2}>
      <CardActionArea
        onClick={handleClick}
        sx={{
          height: "100%",
          display: "flex",
          flexDirection: "column",
          alignItems: "stretch",
          justifyContent: "flex-start",
        }}
      >
        <CardMedia
          sx={{
            height: 140,
            display: "flex",
            alignItems: "center",
            justifyContent: "center",
            backgroundColor: "surface.subtle",
            borderBottom: `2px solid`,
            borderColor: color,
          }}
        >
          {icon}
        </CardMedia>
        <CardContent>
          <Typography variant="h4">{title}</Typography>
          <Typography variant="body2">{description}</Typography>
        </CardContent>
      </CardActionArea>
    </Card>
  );
};

export default ImageLinkCard;
